<div class="content">
  <div
    class="description subtitle"
    [innerHtml]="'AUTOMATIONS.EDITOR.TASKS.JUMP.DESCRIPTION' | translate | iTrustThisHtml"
  ></div>
  <form [formGroup]="form">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.JUMP.STEP' | translate }}
      </glxy-label>
      <mat-select formControlName="step" required="true">
        <mat-option *ngFor="let step of stepOptions" [value]="step.id">
          {{ step.name }}
        </mat-option>
      </mat-select>
      <glxy-error *ngIf="form.controls.step.hasError('required')">
        {{ 'COMMON.REQUIRED' | translate }}
      </glxy-error>
    </glxy-form-field>
    <glxy-alert type="tip" class="description">
      {{ 'AUTOMATIONS.EDITOR.TASKS.JUMP.MAXIMUM_NUMBER_OF_JUMPS_DESCRIPTIONS' | translate }}
    </glxy-alert>
    <div class="maximum-jumps-field">
      <span>
        {{ 'AUTOMATIONS.EDITOR.TASKS.JUMP.MAXIMUM_NUMBER_OF_JUMPS_PRE_INPUT' | translate }}
      </span>
      <span class="maximum-jumps-input">
        <glxy-form-field required="true">
          <input matInput formControlName="maxNumberOfJumps" required />
        </glxy-form-field>
      </span>
      <span>
        {{ 'AUTOMATIONS.EDITOR.TASKS.JUMP.MAXIMUM_NUMBER_OF_JUMPS_POST_INPUT' | translate }}
      </span>
    </div>
    <glxy-error *ngIf="form.controls.maxNumberOfJumps.hasError('pattern')">
      {{ 'AUTOMATIONS.EDITOR.TASKS.JUMP.OUT_OF_BOUNDS' | translate }}
    </glxy-error>
  </form>
</div>
